import { render } from "./ProductReviewsSummary.vue?vue&type=template&id=44ec3953&scoped=true"
import script from "./ProductReviewsSummary.vue?vue&type=script&lang=js"
export * from "./ProductReviewsSummary.vue?vue&type=script&lang=js"

import "./ProductReviewsSummary.vue?vue&type=style&index=0&id=44ec3953&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ec3953"]])

export default __exports__